<template>
    <div v-if="restoreJob && source && destination" @keyup.esc="$root.$emit('CLOSERESTOREVIEW')" class="dialog draggable-item light bg-light w-100-sm w-100-md w-75-lg w-50-xl h-75" id="restoreview">

        <div class="dialog-title pl-10">
            <div>
                <span class="col-11">{{ restoreJob.restore_name }}</span>
                <span class="button square closer" @click="$root.$emit('CLOSERESTOREVIEW')"></span>
            </div>
        </div>

        <div class="dialog-content w-100 overflow px-10">

            <ul data-role="materialtabs"  id="backupView_tabs" data-expand="true"
                class="bg-transparent text-small p-0 tabs-material" style="z-index: 1;">
                <li class="d-flex flex-align-center mt-0 pt-0 active">
                    <a href="#overview">{{ $t("Overview") }}</a>
                </li>
                <li class="d-flex flex-align-center mt-0 pt-0 active">
                    <a href="#source_destination">{{ $t("Sources and destinations") }}</a>
                </li>
            </ul>
            
            <!----------------------INFORMAZIONI PRINCIPALI------------------------------->
            <div id="overview" class="cell">
                <table class="table rounded  small striped bg-white m-0">
                    <tbody>
						<tr>
                            <td>{{ $t("ID") }}:</td>
                            <td class="text-bold">{{ restoreJob.id }}</td>
                        </tr>
                        
                        <tr>
                            <td>{{ $t("Computer name") }}:</td>
                            <td v-if="pcName" class="text-bold">{{ pcName }}</td>
                        </tr>
                        <!--<tr>
                            <td>{{ $t("Backup job ID") }}:</td>
                            <td class="text-bold">{{ restoreJob.job_id }}</td>
                        </tr>-->
                        <tr>
                            <td>{{ $t("Backup job name") }}:</td>
                            <td class="text-bold">{{ restoreJob.job_name }}</td>
                        </tr>
                        <!--<tr>
                            <td>{{ $t("Created at") }}:</td>
                            <td>{{ (restoreJob.inserted_at == null ? "" : convertDate(restoreJob.inserted_at)) }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("Updated at") }}</td>
                            <td>{{ (restoreJob.updated_at == null ? "" : convertDate(restoreJob.updated_at)) }}</td>
                        </tr>-->
                        <tr>
                            <td>{{ $t("Started at") }}</td>
                            <td>{{ dateHelper.toPrettyDate(restoreJob.dt_start_utc) }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("Ended at") }}</td>
                            <td>{{ dateHelper.toPrettyDate(restoreJob.dt_end_utc) }}</td>
                        </tr>
                         <tr>
                            <td>{{ $t("Duration") }}</td>
                            <td>{{ diffDate(restoreJob.dt_start_utc, restoreJob.dt_end_utc) }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("Processed data") }}</td>
                            <td class="no-wrap">{{ prettyBytes(restoreJob.processed_data) }} </td>
                        </tr>
                        <tr>
                            <td>{{ $t("Processed files") }}</td>
                            <td>{{ restoreJob.processed_files }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("Last result") }}</td>
                            <td>
                                <LastResult :lastresult="restoreJob.restore_result" :withLabel="true" />
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t("From") }}</td>
                            <td>{{ $ONEServiceTypeInfo[restoreJob.source_properties.type].name }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("To") }} </td>
                            <td>{{ $ONEServiceTypeInfo[restoreJob.restore_type].name }}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <!----------------------SORGENTI E DESTINAZIONI-------------------------------------------------->
            <div id="source_destination" class="cell">
                <h3 v-if="source.items && source.items.length == 1" class="fg-cobalt d-flex flex-justify-between">
                    <span>{{ $t("Source") }}</span>
                    <span class="badge tertiary h5 inline m-0 text-ultralight">{{ $ONEServiceTypeInfo[source.type].name }}</span>
                </h3>
                <h3 v-if="source.items && source.items.length > 1" class="fg-cobalt d-flex flex-justify-between">
                    <span>{{ $t("Sources") }}</span>
                    <span class="badge tertiary h5 inline m-0 text-ultralight">{{ $ONEServiceTypeInfo[source.type].name }}</span>
                </h3>
                <!--SOURCE - ITEMS-->
                <h5 v-if="source.items && source.items.length == 1" class="mt-4 mb-2">{{ $t("Selected item") }}</h5>
                <div v-if="source.items && source.items.length == 1" class="ml-4">
                    <span :class='source.items[0].entityType.getMetroIcon(source.items[0].path)' class="mr-1"></span>
                    <span>{{ source.items[0].path }}</span>
                </div>
                <h5 v-if="source.items && source.items.length > 1" class="mt-4">{{ $t("Items") }}</h5>
                <ul v-if="source.items && source.items.length > 1" data-role="treeview" data-on-expand-node.stop>
                    <li data-icon="<span class='mif-folder-open'></span>" :data-caption="$t('Items to restore')" data-collapsed="true">
                        <ul>
                            <li v-for="item in source.items" :key="item.path">
                                <span :class='item.entityType.getMetroIcon(item.path)' class="mr-1"></span>
                                <span>{{ item.path }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
                
                
                <!--SOURCE - SERVICE ACCOUNT-->
                <h3 v-if="![undefined, null, '', '-2'].includes(source.id_service_account)" class="mt-4 fg-cobalt">{{ ($t("Source")) }} - {{ $t("Service account") }}</h3>
                <ObjectView v-if="![undefined, null, '', '-2'].includes(source.id_service_account)" :obj="$session.getServiceAccountWithID(source.id_service_account)" :withCopyButton="true" class="mt-4"/>
                
                <h3 v-if="![undefined, null, '', '-2'].includes(source.svcId)" class="mt-4 fg-cobalt">{{ ($t("Source")) }} - {{ $t("Service account") }}</h3>
                <ObjectView v-if="![undefined, null, '', '-2'].includes(source.svcId)" :obj="$session.getServiceAccountWithID(source.svcId)" :withCopyButton="true" class="mt-4"/>
                
                <!--SOURCE - OPTIONS-->
                <h5 class="mt-4">{{ $t("Options") }}</h5>
                <ObjectView :obj="source.options" class="mt-4" :withCopyButton="false"/>

                <h3 v-if="showDestination!='NO'" class="mt-4 fg-cobalt d-flex flex-justify-between">
                    <span v-if="showDestination=='S'">{{ $t("Destination") }}</span>
                    <span v-if="showDestination=='M'">{{ $t("Destinations") }}</span>
                    <span class="badge tertiary h5 inline m-0 text-ultralight">{{ $ONEServiceTypeInfo[destination.type].name }}</span>
                </h3>


                <!--DESTINATION-->

                <h5 v-if="showDestination=='S'" class="mt-4 mb-2">{{ $t("Selected item") }}</h5>
                <!--Nessun elemento in items: destinazione rappresentata nell'oggetto principale-->
                <div v-if="!destination.items && isValid(destination.path)" class="ml-4">
                    <span :class='destination.entityType.getMetroIcon(destination.path)' class="mr-1"></span>
                    <span>{{ destination.path }}</span>
                </div>

                <div v-if="destination.items && destination.items.length == 1" class="ml-4">
                    <span :class='destination.items[0].entityType.getMetroIcon(destination.items[0].path)' class="mr-1"></span>
                    <span>{{ destination.items[0].path }}</span>
                </div>

                <h5 v-if="showDestination=='M'" class="mt-4">{{ $t("Items") }}</h5>
                <ul v-if="showDestination=='M'" data-role="treeview" data-on-expand-node.stop>
                    <li data-icon="<span class='mif-folder-open'></span>" :data-caption="$t('Items to restore')" data-collapsed="true">
                        <ul>
                            <li v-for="item in destination.items" :key="item.path">
                                <span :class='item.entityType.getMetroIcon(item.path)' class="mr-1"></span>
                                <span>{{ item.path }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
                
                <!--DESTINATION - SERVICE ACCOUNT-->
                <h3 v-if="![undefined, null, '', '-2'].includes(destination.id_service_account)" class="mt-4 fg-cobalt">{{ ($t("Destination")) }} - {{ $t("Service account") }}</h3>
                <ObjectView v-if="![undefined, null, '', '-2'].includes(destination.id_service_account)" :obj="$session.getServiceAccountWithID(destination.id_service_account)" :withCopyButton="true" class="mt-4"/>
                
                <h3 v-if="![undefined, null, '', '-2'].includes(destination.svcId)" class="mt-4 fg-cobalt">{{ ($t("Destination")) }} - {{ $t("Service account") }}</h3>
                <ObjectView v-if="![undefined, null, '', '-2'].includes(destination.svcId)" :obj="$session.getServiceAccountWithID(destination.svcId)" :withCopyButton="true" class="mt-4"/>
                
                <h3 v-if="![undefined, null, '', '-2'].includes(destination.IdServiceAccount)" class="mt-4 fg-cobalt">{{ ($t("Destination")) }} - {{ $t("Service account") }}</h3>
                <ObjectView v-if="![undefined, null, '', '-2'].includes(destination.IdServiceAccount)" :obj="$session.getServiceAccountWithID(destination.IdServiceAccount)" :withCopyButton="true" class="mt-4"/>

            </div>

        </div>
        <div class="dialog-actions">
            <ClientMessageView :commands="['restoremethods']"/>
			<button class="button alert"  @click="deleteRestoreJob()">
				<span>{{ $t("Delete") }}</span>
			</button>
			<button class="button js-dialog-close" @click="$root.$emit('CLOSERESTOREVIEW')">{{ $t("Close") }}</button>
		</div>

    </div>
</template>

<script>

import LastResult from "../../utils/LastResult.vue";
import { isValid, prettyBytes, diffDate, assignProperties } from "../../../utils/utilitiesmodule";
import ObjectView from './ObjectView';
import { draggableMixin } from '../../../mixins/draggable-mixin';
import { DateHelper } from "../../../utils/objects";
import ClientMessageView from "./ClientMessageView.vue";


export default {
    name: "RestoreView",
    props: {
        restoreJob: Object
    },
    components: {
        "LastResult": LastResult,
        ObjectView,
        ClientMessageView
    },
    mixins: [draggableMixin],

    data() {
        return {
            //restoreJob: null,
            pcName: null,

            source: null,
            destination: null,

            intoPCRoom: false,
            showDestination: "NO",
            dateHelper: DateHelper
        }
    },

    async beforeDestroy() {
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        this.$root.$off("sendRealtimeJob");
        //this.$root.$off("addBackupsToPage");

        //Se sono nella pagina del computer, non devo far nulla
        if (this.intoPCRoom) {
            return;
        }

        // Se sto chiudendo per aprire la dialog di restore, preservo la room
        if (this.$root.__preservePCRoomOnClose) {
            // opzionale: pulisco il flag subito dopo
            this.$root.__preservePCRoomOnClose=false;
            return;
        }

        //Altrimenti è stata istanziata una connessione socket per il pc del restoreJob, quindi devo stoppare
        this.$root.stopToListenPC(this.restoreJob.id_computer);


    },

    async created() {
        this.intoPCRoom=this.$route.path.contains(this.restoreJob.id_computer);
        if (!this.intoPCRoom) {
            await this.$root.startToListenPC(this.restoreJob.id_computer);
        }

        let self=this;
        self.source=self.restoreJob.source_properties;
        self.destination=self.restoreJob.destination_properties;
        if (self.destination.items&&self.destination.items.length>1) {
            this.showDestination="M";
        }
        else if (
            (!self.destination.items&&isValid(self.destination.path))||
            (self.destination.items&&self.destination.items.length==1)||
            ![undefined, null, '', '-2'].includes(self.destination.id_service_account)||
            ![undefined, null, '', '-2'].includes(self.destination.svcId)
        ) {
            this.showDestination="S";
        }

        
        var pc=self.$session.getRoomPC(); // roompc impostato da startToListenPC
        self.pcName=pc?.pc_name;


        /*self.$root.$on("sendRealtimeJob", realtimeJob => {
            self.restoreJob.isRunning=realtimeJob.isRunning? "R":"NR";
            self.restoreJob.progress=realtimeJob.isRunning? realtimeJob.progress:null;
            self.restoreJob.current_operation=realtimeJob.current_operation;
            self.restoreJob.processed_data_string=realtimeJob.processed_data_string;
            self.restoreJob.restore_result=realtimeJob.lastresult;
        });*/

        self.$root.$on("SETPAGEPROP", (prop, realtimeJob) => {
            if (prop!="restoreJob") {
                return;
            }

            assignProperties(realtimeJob, self.restoreJob, false);
        });

        //####################################################################

    },
    methods: {
        /******************************************BOTTONI*********************************/

        deleteRestoreJob() {

            let self=this;
            this.$root.$on("deleteRestoreJob_feedback", feedback => {

                if (feedback.status==self.$ResultValue.OK) {
                    this.$root.$emit("removeRestoreJobFromList", this.restoreJob.id);
                    this.$root.$emit("CLOSERESTOREVIEW");
                }

                if (feedback.status!=self.$ResultValue.Running) {
                    self.$root.$off("deleteRestoreJob_feedback");
                    return;
                }

            });

            this.$root.$emit("deleteRestoreJob", this.restoreJob);

        },



        convertDate(date) {
            if (!isValid(date))
                return "";
            if (date.toString().indexOf("T")==-1)
                date=this.$moment.utc(date.substr(0, 8)+"T"+date.substr(8), "LLL");

            if (date.toString().indexOf("Z")!=-1)
                date=date.replace("Z", "");

            return this.$moment.utc(date).local().format("LLL");
        },

        diffDate(datestart, dateend) {
            return diffDate(datestart, dateend, this.$moment);
        },

        prettyBytes(data) {
            return prettyBytes(data);
        },

        isValid(value) {
            return isValid(value);
        },

    }
}

</script>
